import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatNumber',
  standalone: true // Mark the pipe as standalone
})
export class FormatNumberPipe implements PipeTransform {
  /**
   * Transforms a number to a string with 2 decimal places and International Number System formatting.
   * @param value The input number to format.
   * @param showCurrency Optional parameter to show currency symbol ($).
   * @returns A formatted string with commas and 2 decimal places (e.g., 1,234,567.89 or $1,234,567.89).
   */
  transform(value: number | null | undefined, showCurrency: boolean = false): string {
    if (value == null || isNaN(value) || !isFinite(value)) {
      return showCurrency ? '$0.00' : '0.00'; // Handle null, undefined, NaN, or Infinity values
    }
    // Format to 2 decimal places
    const numericValue = value.toFixed(2);
    // Split into whole and decimal parts
    const [wholePart, decimalPart] = numericValue.split('.');
    // Add commas to whole part using regex
    const formattedWholePart = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    // Return combined number with commas and decimal places
    const formattedNumber = `${formattedWholePart}.${decimalPart}`;
    
    // Add currency symbol if requested
    return showCurrency ? `$${formattedNumber}` : formattedNumber;
  }
}